<template>
  <div
    ref="blockWrapper"
    :class="['buttons-bottom-header__item _with-popup', {'_with-popup--active': isPopupShow}]"
    data-list-type="jsCompareProduct"
  >
    <a href="/catalog/compare.php" class="buttons-bottom-header__link">
      <div class="buttons-bottom-header__icon">
        <svg
          width="20" height="21"
          viewBox="0 0 20 21" fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd" clip-rule="evenodd"
            d="M9.73047 18.6191H10.7305V2.61914H9.73047V18.6191ZM8.73047 0.619141C8.17818 0.619141 7.73047 1.06686 7.73047 1.61914V19.6191C7.73047 20.1714 8.17818 20.6191 8.73047 20.6191H11.7305C12.2828 20.6191 12.7305 20.1714 12.7305 19.6191V1.61914C12.7305 1.06686 12.2828 0.619141 11.7305 0.619141H8.73047ZM2.73047 12.6191V18.6191H3.73047V12.6191H2.73047ZM1.73047 10.6191C1.17818 10.6191 0.730469 11.0669 0.730469 11.6191V19.6191C0.730469 20.1714 1.17818 20.6191 1.73047 20.6191H4.73047C5.28275 20.6191 5.73047 20.1714 5.73047 19.6191V11.6191C5.73047 11.0669 5.28275 10.6191 4.73047 10.6191H1.73047ZM16.7305 18.6191V7.61914H17.7305V18.6191H16.7305ZM14.7305 6.61914C14.7305 6.06686 15.1782 5.61914 15.7305 5.61914H18.7305C19.2828 5.61914 19.7305 6.06686 19.7305 6.61914V19.6191C19.7305 20.1714 19.2828 20.6191 18.7305 20.6191H15.7305C15.1782 20.6191 14.7305 20.1714 14.7305 19.6191V6.61914Z" fill="#474747"
          />
        </svg>
        <div class="items-count" style="display: none">1</div>
        <div v-if="countItems > 0" class="buttons-bottom-header__icon-count items-count__show">
          {{ countItems }}
        </div>
      </div>
      <span>Сравнить</span>
    </a>
    <div class="buttons-bottom-header__item-popup">
      <div class="buttons-bottom-header__added-products jsCompareProduct">
        <template v-for="(item, key) in items">
          <header-product
            :key="`header-compare-product-${key}`"
            :item="item"
            @deleteItem="deleteItem"
          />
        </template>
      </div>
      <div class="buttons-bottom-header__btn-wrapper">
        <a class="buttons-bottom-header__btn _btn" href="/catalog/compare.php">
          <p>Сравнить товары</p>
          <span />
        </a>
      </div>
    </div>
  </div>
</template>
<script>

import HeaderProduct from '@/components/header-product.vue';
import initHeaderButtonsEffect from '../../../assets/js/modules/function-header-buttons-effect';

export default {
  name: 'app',
  components: {
    HeaderProduct,
  },
  data() {
    return {
      items: {},
      isPopupShow: false,
      isFirstLoad: true,
    };
  },
  computed: {
    countItems() {
      if (this.items) return Object.keys(this.items).length;
      return 0;
    },
    isSessionIdUpdate() {
      return window.isSessionIdUpdate;
    },
  },
  watch: {
    countItems(newValue, oldValue) {
      if (newValue > oldValue && !this.isFirstLoad && !this.isSessionIdUpdate) {
        this.isPopupShow = true;
        setTimeout(() => {
          this.isPopupShow = false;
        }, 2000);
      }
      if (this.isFirstLoad) this.isFirstLoad = false;
    },
  },
  mounted() {
    this.items = JSON.parse(window.localStorage.getItem('compare'));
    if (!this.items?.length) {
      queueMicrotask(() => {
        this.isFirstLoad = false;
      });
    }

    initHeaderButtonsEffect(document.querySelector('[data-list-type="jsCompareProduct"]'));
    this.handlerChanges();
  },
  methods: {
    handlerChanges() {
      window.addEventListener('CompareUpdate', () => {
        this.items = JSON.parse(window.localStorage.getItem('compare'));
      });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.items = JSON.parse(window.localStorage.getItem('compare'));
          window.updateCompare();
        }
      });
    },
    async deleteItem(id, target) {
      const itemsIds = Object.keys(this.items);
      const i = itemsIds.indexOf(id);
      if (i >= 0) {
        itemsIds.splice(i, 1);
      }
      const queryString = new URLSearchParams({
        itemsIds: JSON.stringify(itemsIds),
      });
      const response = await fetch(`/local/ajax/compare/updateItems.php?${queryString}`, {
        method: 'POST',
      });
      if (response.ok) {
        const items = await response.json();

        if (Array.isArray(items) && !items.length) {
          this.isPopupShow = false;
          this.$refs.blockWrapper.classList.remove('_with-popup--active');
          setTimeout(() => {
            this.updateItems(items);
          }, 500);
        } else {
          this.updateItems(items);
        }

        if (window.location.pathname === '/catalog/compare.php') {
          window.loaderShow('#bx_catalog_compare_block');
          window.deleteItemFromComparePage(target, id);
        }
      }
    },
    updateItems(items) {
      this.items = items;
      window.localStorage.setItem('compare', JSON.stringify(items));
      window.updateCompare();
    },
  },
};
</script>
